import { useQuery } from "@tanstack/react-query";
import { getTargetareScoruri } from "@/api/endpoints/targetareConfig";
import { queryKeys } from "@/lib/queryClient";

export function useGetTargetareScoruri() {
  return useQuery({
    queryKey: queryKeys.targetare.scoruri(),
    queryFn: getTargetareScoruri,
    select: (response) => response.data,
    staleTime: 1000 * 60 * 5,
    retry: 1,
  });
}
